<template>
    <v-container fluid class="fill-height pa-0 d-flex justify-center align-center">
      <grid-layout 
         ref="gridLayout1"
        v-model:layout="parsedLayout" 
        :col-num="12" 
        :row-height="rowHeight"
        :margin="[3, 3]"
        :use-css-transforms="true"
        class="dashboard-layout"
        :is-draggable="false" 
        :is-resizable="false"
        @layout-updated="layoutUpdated"
        
      >
        <grid-item 
          v-for="item in parsedLayout" 
          :key="item.i"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :data-grid-item-id="item.i"
          :data-grid-item-type="item.type"
          class="grid-item"
        >
          <v-card class="fill-height pa-0">
            <v-card-text class="fill-height pa-0">
              <div v-if="item.type === 'video'" class="video-container">
                <div v-if="isVideoLoading(item.i)" class="video-loading">
                  <v-progress-circular indeterminate />
                  <p>載入影像中...</p>
                </div>
                <video 
                  :key="item.i"
                  :ref="el => setVideoRef(item.i, el)"
                  @loadeddata="() => onVideoLoaded(item.i)"
                  @error="() => onVideoError(item.i)" 
                  :autoplay="true" 
                  controls
                  :loop="true"
                  class="video-player"
    
                >
                  <source :src="item.value2" type="video/mp4" />
                </video>
              </div>
  
              <div v-else-if="item.type === 'weather-icons'" class="weather-container">
                <v-list>
                  <v-list-item
                    v-for="(weatherItem, index) in parseWeatherValue(item.value)"
                    :key="index"
                    class="mb-2"
                  >
                    <template v-slot:prepend>
                      <v-avatar size="48">
                        <v-img :src="weatherItem.icon" :alt="weatherItem.text" />
                      </v-avatar>
                    </template>
                    <v-list-item-title class="text-h6">
                      {{ weatherItem.text }}: {{ weatherItem.value }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </div>

              <div v-else-if="item.type === 'webpage'" class="webpage-container">
              <iframe 
                :src="item.value2" 
                class="webpage-frame"
                :sandbox="webpageSandbox"
                loading="lazy"
                @load="() => onIframeLoaded(item.i)"
              ></iframe>
              <div v-if="isIframeLoading(item.i)" class="iframe-loading">
                <v-progress-circular indeterminate />
                <p>載入網頁中...</p>
              </div>
            </div>

            <div v-else-if="item.type === 'marquee'" class="marquee-container" >
              <div class="marquee" :style="getMarqueeStyles(item)">
                <div class="marquee-text">{{ item.value2 }}</div>
              </div>
            </div>

           <div v-else-if="item.type === 'time'" class="current-time">
              <div >
                <span>{{ currentTime }}</span>
              </div>
            </div>
            
            <div v-else-if="item.type === 'carousel'" >
              <v-carousel 
                v-if="images.length"
                :continuous="true"
                :show-arrows="false"
                hide-delimiters
                hide-delimiter-background
                :interval="cycle"
                :cycle="true"
                class="carousel-container1"
                 height="100%"
                  width="100%"
              >
                <v-carousel-item
                  v-for="(image, index) in images"
                  :key="index"
                  class="carousel-item-wrapper1"
                >
                <v-img
                  :src="image.url"
                  object-fit:contain
                  class="carousel-image1"
                  max-width="100%"
                ></v-img>
                
                </v-carousel-item>
              
              </v-carousel>
            </div>
            </v-card-text>
          </v-card>
        </grid-item>
      </grid-layout>
    </v-container>
  </template>
  
  <script setup>
  import { ref, onMounted, onUnmounted, computed, nextTick } from "vue";
  import { GridLayout, GridItem } from "vue3-grid-layout";
  import axios from "axios";
  
  
    const props = defineProps({
    name: {
        type: String,
        //required: true,
        default: 'M2',
        //validator: (value) => value.length > 2,
    },
    secs: {
        type: Number,
        default: 5,
    },
    // Shorthand:
    // isEnabled: Boolean,
    });
    console.log('Received props:', props);
  const iframeStates = ref(new Map());
  const cycle=ref(props.secs*1000);
  const name=ref(props.name);
  const gridLayout1 = ref(null);

  const webpageSandbox = computed(() => [
    'allow-scripts',
    'allow-same-origin',
    'allow-forms',
    'allow-popups'
    ].join(' '));

  const isIframeLoading = (id) => iframeStates.value.get(id)?.loading || false;

  const onIframeLoaded = (id) => {
    iframeStates.value.set(id, { loading: false });
  };

  const getMarqueeStyles = (item) => {
    

  //const speed = item.speed || 20; 
  const baseSpeed = 0.5;
  const minDuration = 10;
  //console.log('getMarqueeStyles item',item.value.length);
  const speed = Math.max(minDuration, item.value.length / parseFloat(baseSpeed));
  //const containerEl = gridLayout1.value.$el.querySelector(`[data-grid-item-id="${item.i}"]`);
  //const containerHeight = containerEl ? containerEl.offsetHeight * 0.95 : 0; // 95% height
  //console.log('getMarqueeStyles',speed);
  console.log('item.value.length',item.value.length);
  console.log('speed',speed);
  console.log('---timeHeight.value---',timeHeight.value);
  const gridItemEl = gridLayout1.value?.$el.querySelector(`[data-grid-item-type="time"]`);
  console.log('gridItemEL',gridItemEl);
  console.log('gridItemEl.offsetWidth',gridItemEl.offsetWidth);
  if (gridItemEl)
  {
    timeHeight.value=gridItemEl.offsetWidth/20*2;
    document.documentElement.style.setProperty('--time-font-size', `${timeHeight.value}px`);
  }
    return {
        '--marquee-speed': `${speed}s`,
        '--marquee-font-size': `${marqueeHeight.value}px`,
        '--time-font-size':`${timeHeight.value}px`
    };
  };

  const fontSize=(itme)=>{

  }

  const parseCarouselItems = (value) => {
        if (typeof value === 'string') {
            try {
            return JSON.parse(value);
            } catch {
            return [];
            }
        }
        return Array.isArray(value) ? value : [];
  };

  const apiUrl = window.config.API_URL;
  const layout = ref([]);
  const videoStates = ref(new Map());
  const videoRefs = ref(new Map());
  const timeouts = new Map();
  const rowHeight = ref(150);
  const WEATHER_PANEL_WIDTH = 2; 
  const currentTime = ref(' ');
  const images=ref([]);
  const weatherData=ref([]);
  const formatTime = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const updateCurrentTime = () => {
        //console.log('updateCurrentTime');
    currentTime.value = formatTime(new Date());
  };

  let timer = null;
  let timerWheather=null;
  const marqueeHeight=ref(30);
  const timeHeight=ref(30);

  const layoutUpdated = () => {
    console.log('call layoutUpdated');
    
  nextTick(() => {
    parsedLayout.value.forEach(item => {
      console.log(`Querying for data-grid-item-id="${item.i}"`);
      console.log('gridLayout1.value?.$el',gridLayout1.value?.$el);
      const gridItemEl = gridLayout1.value?.$el.querySelector(`[data-grid-item-id="${item.i}"]`);
      //const gridItemE2 = gridLayout1.value?.$el.querySelector(`[data-grid-item-type="${item.type}"]`);
      console.log('gridItemEl', gridItemEl);
      //console.log('gridItemE2', gridItemE2);
      if (gridItemEl) {
        const width = gridItemEl.offsetWidth;
        const height = gridItemEl.offsetHeight;
        console.log('height',gridItemEl.offsetHeight);
        const gridItemType = gridItemEl.getAttribute('data-grid-item-type');
        console.log('type',gridItemType );
        if (gridItemType==='marquee')
        {
          marqueeHeight.value=height*0.95;
          console.log('marqueeHeight.value 0:',marqueeHeight.value);
        }
        else if (gridItemType==='time')
        {
          timeHeight.value=width/20.0*2;
          console.log('timeHeight.value 0:',timeHeight.value);
          document.documentElement.style.setProperty('--time-font-size', `${timeHeight.value}px`);
        }
        console.log(`Item ${item.i} - Width: ${width}px, Height: ${height}px`);
      }
    });
    
  });
  
};

  const parsedLayout = computed(() => {
    if (!layout.value?.layoutJson) return [];
    try {
      const parsed = JSON.parse(layout.value.layoutJson);
      return parsed.map(item => {
        
        return item;
      });
    } catch (error) {
      console.error('Error parsing layout:', error);
      return [];
    }
  });
  
  const getAdjustedWidth = (item) => {
    if (item.type === 'weather-icons') {
      return WEATHER_PANEL_WIDTH; // Fixed width for weather panel
    } else if (item.type === 'video') {
      return 12 - WEATHER_PANEL_WIDTH; // Auto-grow to fill remaining space
    }
    else if (item.type==='time'){
        console.log(item.type);
    }
    return item.w; // Default width for other items
  };
  
  const parseWeatherValue = (value) => {
    
    
    console.log('[parse value]',value);
    //console.log('weatherData',weatherData.value);
    if (!value) return [];
    return value.map(item => {
      const parts = item.split(',');
      return {
        text: parts[0] || '',
        value: parts[1] || '',
        icon: parts[2] || ''
      };
    });

    return value.map(item => (
        {

        icon: item.icon,
        text: item.text,
        value: weatherData.value.find((x)=>x.icon===item.icon).value || item.value // Use updated value if available
    }));

  };
  
  const isVideoLoading = (id) => videoStates.value.get(id)?.loading || false;
  
  const setVideoRef = (id, el) => {
    if (el) {
      videoRefs.value.set(id, el);
      //checkAndPlayVideo(el);
    } else {
      videoRefs.value.delete(id);
    }
  };
  
  const initVideoLoading = (id) => {
    if (timeouts.has(id)) {
      clearTimeout(timeouts.get(id));
    }
    
    videoStates.value.set(id, { loading: true, error: false });
    
    const timeoutId = setTimeout(() => {
      const state = videoStates.value.get(id);
      if (state?.loading) {
        videoStates.value.set(id, { loading: false, error: true });
        console.error(`Video ${id} loading timeout`);
      }
      timeouts.delete(id);
    }, 10000);
    
    timeouts.set(id, timeoutId);
  };
  
  const onVideoLoaded = (id) => {
    if (timeouts.has(id)) {
      clearTimeout(timeouts.get(id));
      timeouts.delete(id);
      const video = videoRefs.value.get(id);
      console.log('onVideoLoadad',video);
      checkAndPlayVideo(video);
    }
    videoStates.value.set(id, { loading: false, error: false });
  };

  const checkAndPlayVideo=(video)=> {
    console.log('check video',video);
        if (video && video.paused) {
        // Play muted initially
        video.muted = true;
        video.play().then(() => {
            const unmuteOnUserInteraction = () => {
            video.muted = false;
            video.removeEventListener('click', unmuteOnUserInteraction);
            video.removeEventListener('touchstart', unmuteOnUserInteraction);
            };
            video.addEventListener('click', unmuteOnUserInteraction);
            video.addEventListener('touchstart', unmuteOnUserInteraction);
        }).catch(error => {
            console.error('Autoplay failed:', error);
        });
        }
    };
  
  
  const onVideoError = (id) => {
    if (timeouts.has(id)) {
      clearTimeout(timeouts.get(id));
      timeouts.delete(id);
    }
    videoStates.value.set(id, { loading: false, error: true });
  };
  
  const updateRowHeight = () => {
    const vh = window.innerHeight;
    rowHeight.value = Math.floor(vh / 12);
  };
  
  const loadLayout = async () => {
    try {
      const response = await axios.post(`${apiUrl}/template/getTemplateByName2?name=${name.value}`);
      //console.log("response:", JSON.stringify(response.data, null, 2));
      layout.value = response.data.template;
      console.log('layout.value',layout.value);
      let maxX=0;
      let maxY=0;
      let minX=999;
      let minY=999;
      
        //console.log('w,h',window.innerWidth+','+window.innerHeight);
        //let xRatio=1920/window.innerWidth;
        //let yRatio=1080/window.innerHeight;
        const itemWMax=ref(null);
        const itemWMin=ref(null);
        const itemHMax=ref(null);
        const itemHMin=ref(null);
        const bFirst=ref(true);
        parsedLayout.value.forEach((item) => {
            console.log('item1', item);
        if (itemWMax.value===null)
        {
            console.log('assign null');
            //bFirst.value=false;
            itemWMax.value=item;
            itemWMin.value=item;
            itemHMax.value=item;
            itemHMin.value=item;
            console.log('itemWMax0',itemWMax.value);
            console.log('itemWMin0',itemWMin.value);
            console.log('itemHMax0',itemHMax.value);
            console.log('itemHMin0',itemHMin.value);
        }
        //console.log('item00',item.x+item.w);
        //console.log('item11',itemWMax.value.x+itemWMax.value.w);

        if (item.x+item.w < itemWMin.value.x+itemWMin.value.w)
        {
            //console.log('1');
            itemWMin.value=item;
            //console.log('find xMin', itemWMin.value.x+itemWMin.value.w);
            
        }
        console.log('itemHMin',itemHMin.value);
        if (item.y+item.h < itemHMin.value.y+itemHMin.value.h)
        {
            //console.log('2');
            itemHMin.value=item;
            //console.log('find yMin', itemHMin.value.y+itemHMin.value.h);
            
        }
        if (item.x+item.w > itemWMax.value.x+itemWMax.value.w)
        {
            //console.log('3');
            itemWMax.value=item;
            //console.log('find wMax', itemWMax.value.x+itemWMax.value.w);
            
        }
        if (item.y+item.h > itemHMax.value.y+itemHMax.value.h)
        {
            //console.log('4');
            itemHMax.value=item;
            //console.log('find hMax', itemHMax.value.y+itemHMax.value.h);
        }
        //console.log('itemWMin',itemWMin.value);
        //console.log('itemWMax',itemWMax.value);
        //console.log('itemHMin',itemHMin.value);
        //console.log('itemHMax',itemHMax.value);
        
        });

        //let X = maxX - minX;
        //let Y = maxY - minY;
        //console.log('X,Y',X+','+Y);
        
        let xRatio = itemWMax.value.x+itemWMax.value.w > 0 ? 12/(itemWMax.value.x+itemWMax.value.w):1.0;
        let yRatio = itemHMax.value.x+itemHMax.value.w > 0 ? 30/(itemHMax.value.x+itemHMax.value.w):1.0;
        console.log('xRatio',xRatio);
        console.log('yRatio',yRatio);

    
      parsedLayout.value.forEach((item) => {
      
        console.log("x,y",(maxX-minX)+','+(maxY-minY));
        item.w = item.w*xRatio; // Scale width
        //item.h = item.h*yRatio; // Scale height
        item.x = item.x*xRatio;
        //item.y = item.y*yRatio;
        console.log('item2', item);
      });
    
      parsedLayout.value.forEach(item => {
        console.log('item.type',item.type);
        console.log('item.i',item.i);
        if (item.type === 'video') {
          
          initVideoLoading(item.i);
        }
        else if (item.type === 'webpage') {
          iframeStates.value.set(item.i, { loading: true });
        }
        else if (item.type === 'time') {
            console.log('show time');
            updateCurrentTime();
            timer = setInterval(updateCurrentTime, 1000); 
        }
        else if (item.type==='weather-icons')
        {
            
            console.log('item.value',item.value);
            const weatherIcons=Array.isArray(item.value) ? [...item.value] : [];
            weatherData.value.push(weatherIcons);
            console.log('json weather',weatherData.value);
            
        }
      });

      
      const dbImages = await Promise.all(response.data.lstImageData.map(async image => {
            
            const response = await fetch(`data:image/jpeg;base64,${image}`);
            const blob = await response.blob();
            
            const file = new File([blob], `image_${image.id}.jpg`, { type: 'image/jpeg' });
            
            return {
              url: URL.createObjectURL(file),
              file: file,
            };
          }));
          console.log('lstImageData', dbImages);
        //images.value = [...images.value, ...dbImages];
        
          images.value = [];
          dbImages.forEach(imageFile => {
            console.log('imageFile',imageFile);
            images.value.push(imageFile);
            
          });
    } catch (error) {
      console.error('Error loading layout:', error);
    }
  };

  const updateWeather= async ()=>{
      try {
        const response = await axios.get(`${apiUrl}/weather/weather2`);
        //console.log('weather',response.data);
        for(var i=0;i<response.data.lstWeathers.length;i++)
      {
        let w=response.data.lstWeathers[i];
        //console.log('w',w);
      }
        weatherData.value.forEach((item)=>{
            //console.log('item.icon',item.icon);
            const found=response.data.lstWeathers.find((x)=>x.icon===item.icon);
            if (found!==undefined)
        {
            //weatherItem.value.value=found.value;
            //console.log('found',found);
            item.value=found.value;
            
        }
        });
        //console.log('weatherData=>',weatherData.value);
        
        //this.dashboardItems = response.data;
      } catch (error) {
        console.error('Error fetching dashboard items:', error)
      }
    
  };
  
  onMounted(() => {
    
    console.log('name',name.value);
    //console.log('gridLayout',gridLayout.value);
    
    console.log('cycle',cycle.value);
    updateRowHeight();
    window.addEventListener('resize', updateRowHeight);
    loadLayout();
    timerWheather = setInterval(updateWeather, 10000); 
    //layoutUpdated();
  });
  
  onUnmounted(() => {
    window.removeEventListener('resize', updateRowHeight);
    timeouts.forEach(timeoutId => clearTimeout(timeoutId));
    timeouts.clear();
    if (timer) {
        clearInterval(timer);
    if (timerWheather){
        clearInterval(timerWheather);
    }
  }
  });
  </script>
  
  <style scoped>

.carousel-container {
  height: 100%;
  width: 100%;
  align-items: center;
}

.v-carousel-item img {
  width: 100%;
  height: 100%;
  object-fit: contain; 
}


  .current-time {
    text-align: center;
    vertical-align: middle;
    width: 100%;
    height: 100%;
    font-family: '新細明體';
  font-size: var(--time-font-size);
  /*font-size: 80px;*/
  font-weight: 700;
  margin: 0px;
  color:red;
  display: flex;
  align-items: center;  
  justify-content: center; 
}

  .dashboard-layout {
    width: 100%;
    height: 100vh;
    background-color:darkslategrey;
  }
  
  .grid-item {
    width:100%;
    height: 100%;
    overflow: hidden;
  }
  
  .fill-height {
    height: 100%;
  }
  
  .video-container {
    position: relative;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  
  .video-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 1;
  }
  
  .video-player {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border: 2px solid red;
  }
  
  .weather-container {
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
    
  }

  .marquee-container {
    
      width: 100%;
      height: 100%; 
      overflow: hidden;
      white-space: nowrap;
      position: relative;
  display: flex; 
  align-items: center;  

    }

    

    .marquee {
      display: inline-block;
      animation: marquee var(--marquee-speed) linear infinite;
      padding: 0px;
      transform: translateX(0);
    }

    @keyframes marquee {
      0% {
        transform: translateX(0%);
      }
      100% {
        transform: translateX(-100%);
      }
    }

    /* Optional: Pause animation on hover */
    .marquee:hover {
      animation-play-state: paused;
    }
  
    .marquee-text {
      font-family: '標楷體';
    font-size: var(--marquee-font-size);
    line-height: 1; 
    display: inline-flex; 
    align-items: center; 
    }

    .aspect-ratio-box {
  position: relative;
  width: 100%;
  height: 100%;
  overflow:hidden;
}

.carousel-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.carousel-item-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.carousel-image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; 
  width: 100%;
}

.carousel-image {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain; 
}

.custom-carousel {
  display: flex;
  flex-direction: column;
  align-items: center;
}

html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#app {
  width: 100%;
  max-width: 1920px; /* Optional: set a max width if needed */
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.v-container.fill-height {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dashboard-layout {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Ensure grid layout is centered */
.grid-layout {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
  </style>